import {effect, Injectable, signal, WritableSignal} from '@angular/core';
import {CatalogoInterface} from "../../users/interfaces/proyecto.interface";
import {DropdownChangeEvent} from "primeng/dropdown";

@Injectable({providedIn: 'root'})
export class FiltersService {
    private _rangeEvent: WritableSignal<Date[]> = signal([])
    public selectedRange: Date[] = [];
    public filters: CatalogoInterface[] = []
    public selectedFilter: CatalogoInterface | null = null;
    constructor() {
        this.filters = this.defaultFilters();
        this.selectedFilter = this.filters[0]!
        this.defaultRange();
    }
    ngOnInit(): void {
        console.log(`ngOnInit() ->` + this.constructor.name)
    }
    calculateDateRange($event: DropdownChangeEvent) {
        this.selectedRange = [];
        this.selectedFilter = $event.value
        const currentDate = new Date();
        let startDate = new Date(currentDate);
        const match = this.selectedFilter?.descripcion.match(/\((\d+)\)/);
        if (match && match[1]) {
            const days = parseInt(match[1], 10);
            startDate.setDate(currentDate.getDate() - days);
            this.selectedRange.push(startDate);
            this.selectedRange.push(currentDate);
        } else {
            this.selectedRange = []
        }
        this._rangeEvent.set(this.selectedRange);
        return this.selectedRange;
    }
    onSelect() {
        console.log(`onSelect()`);
        this.selectedFilter = this.filters![this.filters!.length - 1]
        this._rangeEvent.set(this.selectedRange!);
    }
    private defaultRange() {
        this.selectedRange = [];
        const currentDate = new Date();
        let startDate = new Date(currentDate);
        const days = 7;
        startDate.setDate(currentDate.getDate() - days);
        this.selectedRange.push(startDate);
        this.selectedRange.push(currentDate);
        this._rangeEvent.set(this.selectedRange);
    }
    private defaultFilters() {
        return [{
            id: '1',
            descripcion: '(7) dias',
            estado: true
        },
            {
                id: '2',
                descripcion: '(30) dias',
                estado: true
            },
            {
                id: '3',
                descripcion: '(60) dias',
                estado: true
            },
            {
                id: '4',
                descripcion: '(120) dias',
                estado: true
            },
            {
                id: '5',
                descripcion: 'Personalizado',
                estado: true
            }];
    }
    get rangeEvent(): WritableSignal<Date[]> {
        return this._rangeEvent;
    }
    set rangeEvent(value: WritableSignal<Date[]>) {
        this._rangeEvent = value;
    }
    rangeEventEffect = effect(() => {
        console.log(`_rangeEvent ->${this._rangeEvent()}`);
    })
}
